import {NgModule}                        from '@angular/core';
import {RouterModule, Routes}            from '@angular/router';
import {ApContactComponent}              from './components/ap-contact.component';
import {ApLoginComponent}                from './components/ap-login.component';
import {ApRequestPasswordResetComponent} from './components/ap-request-password-reset.component';
import {ApPasswordRecoveryComponent}     from './components/ap-password-recovery.component';
import {ApInvitationsComponent}          from './components/ap-invitations.component';
import {ApInvitationsGuard}              from '../guards/ap-invitations-guard';

const routes: Routes = [
  {
    path: '',
    component: ApLoginComponent,
  },
  {
    path: 'request-password-reset',
    component: ApRequestPasswordResetComponent,
  },
  {
    path: 'password-recovery',
    component: ApPasswordRecoveryComponent,
  },
  {
    path: 'contact',
    component: ApContactComponent,
  },
  {
    path: 'invitations',
    canActivate: [ApInvitationsGuard],
    component: ApInvitationsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApLoginRoutes {
}
